import React, { useState, useEffect } from 'react'
import styles from './LeadQualityScreen.module.css'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LeadQualityCardComponent from './LeadQualityCardComponent';
import DropdownWithValue from '../../Components/DropDown/DropdownWithValue';
import DownloadIconGreen from '../../Assets/Images/download-icon-green.svg';
import { connect, useDispatch } from "react-redux";
import { fetchLeadEvaluationReports, fetchReportDropdown } from '../../Services/reports';
import { downloadDashboardAsPDF } from '../../Services/reports';
import { setLQCReportDate } from '../../Redux/actions';

interface LeadQualityHeroComponentProps {
    leadCallingScoreType: any,
    user: any,
    organizationData: any,
}

const LeadQualityHeroComponent: React.FC<LeadQualityHeroComponentProps> = ({ leadCallingScoreType, user , organizationData}) => {
    const [optionSelected, setOptionSelected] = useState<any>({
        label: "Select",
        value: "Select",
    });
    const [dropdownOptions, setDropdownOptions] = useState<any>([]);
    const [reportsData, setReportsData] = useState<any>([]);
    const dispatcher = useDispatch();
    const [showDownloadButton, setShowDownloadButton] = useState<any>(false);
    const [getPDFLink, setGetPDFLink] = useState<any>("Not Available");
    const isInWebView = !!window.ReactNativeWebView;
    useEffect(()=>{
        const setDropdown = async () => {
            await fetchReportDropdown(Number(user.user_super_oid),setDropdownOptions);
        };
        setDropdown();
    },[user.user_super_oid])

    useEffect(() => {
        // console.log("organizationData",organizationData)
        const setLeadEvaluationReports = async () => {
            await fetchLeadEvaluationReports(Number(user.user_super_oid), optionSelected.value, "Lead Evaluation Report", setReportsData,dispatcher);
        };

        if (user.user_super_oid) {
            if(optionSelected.value !== "Select"){
                setLeadEvaluationReports();
            }
        }
    }, [
        user.user_super_oid, optionSelected
    ])

    useEffect(()=>{
        if(dropdownOptions.length > 0){
            setOptionSelected(dropdownOptions[0]);
            dispatcher(setLQCReportDate(dropdownOptions[0].value))
        }
    },[dropdownOptions])

    useEffect(() => {
      if (isInWebView === true) {
        const foundValue = dropdownOptions.find(
          (item: any) =>
            item.value === optionSelected.value &&
            item.label === optionSelected.label
        );
        if (foundValue) {
          if (
            foundValue.pdfLink === "Not Available" ||
            foundValue.pdfLink === undefined ||
            foundValue.pdfLink === null
          ) {
            setShowDownloadButton(false);
            setGetPDFLink("Not Available");
          } else {
            setShowDownloadButton(true);
            setGetPDFLink(foundValue.pdfLink);
          }
        }
        else{
            setShowDownloadButton(false);
        }
      } else {
        setShowDownloadButton(true);
      }
    }, [optionSelected]);

    return (
        <div className={styles.LqsHeroSec}>
            <div className={styles.LqsHeroTitle}><span className={styles.Backarrow}></span>Lead Evaluation Report</div>
            <div data-hide-in-pdf className={styles.LqsHeroActions}>
                <div className={styles.LqsSelectReport}>
                    <span className={styles.LqsSelectReportLabel}>Select the report</span>
                    <DropdownWithValue
                        option={dropdownOptions}
                        selectedValue={optionSelected}
                        classNameModifier={styles.LqsSelectReportselect}
                        setSelectedValue={(value) => {
                            setOptionSelected(value);
                            dispatcher(setLQCReportDate(value.value))
                        }
                        }
                    />
                </div>
                {showDownloadButton && (
                    <a className={styles.LqsReportDownloadCta} style={{cursor:"pointer"}} onClick={()=>{
                        if (isInWebView === true) {
                            if(getPDFLink !== "Not Available" || getPDFLink !== ""|| getPDFLink !== undefined|| getPDFLink !== null){
                                window.ReactNativeWebView?.postMessage(
                                    JSON.stringify({
                                      type: "PDF_LINK",
                                      fileLink: getPDFLink,
                                      organization_name:organizationData.organization_name,
                                      dateRange:optionSelected.label
                                    })
                                  );
                            }
                        }
                        else{
                            downloadDashboardAsPDF(organizationData.organization_name,optionSelected.label);
                        }
                    }}>
                        <img src={DownloadIconGreen} alt="download icon" />
                    </a>
                )}
            </div>
            <div className={styles.LqsHroSubTitle}><InfoOutlinedIcon className={styles.infoIcon} /> Based on your Lead Activity vs. other agents in your city on ReadPro.</div>
            <div className={styles.LqsCards}>
                {
                    reportsData.map((report: any) => {
                        return (
                            <LeadQualityCardComponent
                                leadQualityTitle={report.report_header}
                                leadQualityScoreType={report?.report_score_desc ? report.report_score_desc.toLowerCase() : "" }
                                leadQualityScore={report.report_total_score}
                                displayReport={report.report_display}
                            />
                        )
                    })
                }
            </div>
        </div>
    )
}


const mapStateToProps = (state: any) => {
    return {
        user: state.user.data,
        organizationData: state.organization.organizationData,
    };
};

export default connect(mapStateToProps)(LeadQualityHeroComponent);